
import { viewport } from './toolbox.js';


export default function () {
	$('a[href*="#"]:not([href="#"])').click(function(e) {

		// if($('html').hasClass('ios') || viewport().width < 1050) {
		// 	$('body, html').removeClass('navigation');
		// 	return;
		// }

		if($(e.target).hasClass('popup-inline-videobox') || $(e.target).hasClass('dynamic-video-player')) return;

		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {

			var hash = this.hash;
			var target = $(hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
			var targetPos, currentPos, delta, dur;
			var offset = (viewport().width < 1050) ? 59 : 69;
			if(target.hasClass('tab-content')) return;
			if (target.length) {

				event.preventDefault();

				$('body, html').removeClass('navigation');
				target.prop('id', 'target');
				targetPos = target.offset().top - offset;

				// currentPos = $(window).scrollTop()
				// delta = Math.abs(targetPos - currentPos);
				// dur = delta/2000;
				location.hash = hash;

				//console.log(delta, dur)
				// TweenMax.to(window, 1, {scrollTo:targetPos, delay: 0.1, ease:Power2.easeInOut, onComplete:function(){
				// 	target.prop('id', hash.split('#')[1]);
				// }});
				$('html, body').animate({scrollTop: targetPos}, 1000, 'swing', function() {
				   target.prop('id', hash.split('#')[1]);
				});

			}
		}
	});

};
